document.addEventListener('DOMContentLoaded', () => {
  const moveArticleSections = () => {
    const movableSections = document.querySelectorAll('[data-article-movable][data-article-slot-id]');

    movableSections.forEach((section) => {
      const slotId = section.dataset.articleSlotId?.trim();
      if (!slotId) return;

      const slot = document.querySelector(
        `.article__content [data-article-slot="${CSS.escape(slotId)}"], .rte [data-article-slot="${CSS.escape(slotId)}"]`
      );

      if (!slot) return;

      slot.replaceWith(section);
      section.classList.add('is-article-mounted');
    });
  };

  const initArticleToc = () => {
    const articleContent = document.querySelector('.article__content');
    if (!articleContent) return;

    const headings = articleContent.querySelectorAll('h2');
    if (!headings.length) return;

    const existingToc = document.querySelector('[data-article-toc]');
    if (existingToc) existingToc.remove();

    const tocBlock = document.createElement('div');
    tocBlock.className = 'article-toc';
    tocBlock.setAttribute('data-article-toc', '');

    const labelWrap = document.createElement('div');
    labelWrap.className = 'article-toc__label-wrap';
    labelWrap.innerHTML = '<span class="article-toc__label">INDEX</span>';
    tocBlock.appendChild(labelWrap);

    const box = document.createElement('div');
    box.className = 'article-toc__box';

    const tocList = document.createElement('ol');
    tocList.className = 'article-toc__list';
    tocList.setAttribute('data-article-toc-list', '');

    headings.forEach((heading, index) => {
      const number = index + 1;
      const id = `article-toc-1-heading-${number}`;

      heading.setAttribute('id', id);

      const li = document.createElement('li');
      li.className = 'article-toc__item';

      // [カスタマイズ追記 2026-10-08] 見出しテキストを innerHTML で入れると「<」「&」などの記号が
      // HTMLとして解釈されて消えることがあるため、要素を作って textContent で入れる
      const link = document.createElement('a');
      link.className = 'article-toc__link';
      link.href = `#${id}`;

      const num = document.createElement('span');
      num.className = 'article-toc__num';
      num.textContent = `${number}.`;

      const text = document.createElement('span');
      text.className = 'article-toc__text';
      text.textContent = heading.textContent.trim();

      link.append(num, text);
      li.appendChild(link);

      tocList.appendChild(li);
    });

    box.appendChild(tocList);

    // [カスタマイズ追記 2026-10-09] スマホで目次が画面の6割ほどを占め本文が遠かったため、
    // 項目が5つ以上のときは最初の3つだけ表示し「すべて見る」で開閉できるようにする（隠すのはSPのみ。CSS側で制御）
    const TOC_VISIBLE_COUNT = 3;
    if (headings.length > TOC_VISIBLE_COUNT + 1) {
      tocBlock.classList.add('is-collapsible', 'is-collapsed');
      tocList.id = 'article-toc-list';

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'article-toc__toggle';
      toggle.setAttribute('aria-controls', tocList.id);
      toggle.setAttribute('aria-expanded', 'false');

      const openLabel = `すべて見る（全${headings.length}項目）`;
      toggle.textContent = openLabel;

      toggle.addEventListener('click', () => {
        const isCollapsed = tocBlock.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', String(!isCollapsed));
        toggle.textContent = isCollapsed ? openLabel : '閉じる';
      });

      box.appendChild(toggle);
    }

    tocBlock.appendChild(box);

    headings[0].insertAdjacentElement('beforebegin', tocBlock);
  };

  const initSupervisor = () => {
    const holder = document.querySelector('[data-article-supervisor-holder]');
    if (!holder) return;

    const supervisor = holder.querySelector('.article-supervisor');
    if (!supervisor) return;

    const tocBlock = document.querySelector('.article__content [data-article-toc]');

    if (tocBlock) {
      tocBlock.insertAdjacentElement('afterend', supervisor);
    } else {
      const articleContent = document.querySelector('.article__content');
      const firstH2 = articleContent?.querySelector('h2');
      if (firstH2) {
        firstH2.insertAdjacentElement('beforebegin', supervisor);
      } else if (articleContent) {
        // [カスタマイズ追記 2026-10-08] 見出し(h2)も目次もない記事では置き場所がなく、
        // 直後の holder.remove() で監修者ごと消えていたため、本文の先頭に置く
        articleContent.prepend(supervisor);
      }
    }

    holder.remove();
  };

  const initSimpleTables = async () => {
  const tables = document.querySelectorAll('table.simple-table');

  const fetchSimpleTableItem = async (cell) => {
    const link = cell.querySelector('a');
    const fallbackTitle = cell.textContent.trim();

    if (!link) {
      return {
        type: 'manual',
        title: fallbackTitle,
        url: '',
        image: '',
        buttonText: ''
      };
    }

    const rawUrl = link.getAttribute('href');
    let title = fallbackTitle;
    let image = '';
    let type = 'manual';
    let buttonText = '';

    let parsedUrl;

    try {
      parsedUrl = new URL(rawUrl, window.location.origin);
    } catch (error) {
      return {
        type,
        title,
        url: rawUrl,
        image,
        buttonText
      };
    }

    const pathname = parsedUrl.pathname.replace(/\/$/, '');
    const displayUrl = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;

    try {
      let fetchUrl = '';

      if (pathname.includes('/products/')) {
        type = 'product';
        buttonText = '購入する';
        fetchUrl = `${pathname}.js`;
      } else if (pathname.includes('/collections/')) {
        type = 'collection';
        buttonText = '一覧を見る';
        fetchUrl = `${pathname}?view=simple-table-json`;
      }

      if (fetchUrl) {
        const response = await fetch(fetchUrl);

        if (response.ok) {
          const data = await response.json();

          title = data.title || fallbackTitle;

          if (type === 'product') {
            image = data.featured_image || '';
          }

          if (type === 'collection') {
            image = data.image || '';
          }
        }
      }
    } catch (error) {
      console.warn('Simple table item fetch failed:', rawUrl, error);
    }

    return {
      type,
      title,
      url: displayUrl,
      image,
      buttonText
    };
  };

  for (const table of tables) {
    if (table.dataset.simpleTableEnhanced === 'true') continue;
    table.dataset.simpleTableEnhanced = 'true';

    const theadCells = table.querySelectorAll('thead th');
    const bodyRows = table.querySelectorAll('tbody tr');

    if (theadCells.length < 2 || bodyRows.length === 0) continue;

    const tableItems = await Promise.all(
      Array.from(theadCells).slice(1).map(fetchSimpleTableItem)
    );

    Array.from(theadCells).slice(1).forEach((cell, index) => {
      const item = tableItems[index];
      if (!item) return;

      const card = document.createElement('div');
      card.className = 'simple-table__product-card';

      if (item.image) {
        const imageWrap = document.createElement('div');
        imageWrap.className = 'simple-table__product-image-wrap';

        const imageLink = document.createElement(item.url ? 'a' : 'div');
        if (item.url) imageLink.href = item.url;

        const img = document.createElement('img');
        img.className = 'simple-table__product-image';
        img.src = item.image;
        img.alt = item.title;

        imageLink.appendChild(img);
        imageWrap.appendChild(imageLink);
        card.appendChild(imageWrap);
      }

      const title = document.createElement('p');
      title.className = 'simple-table__product-title';

      const titleLink = document.createElement(item.url ? 'a' : 'span');
      titleLink.className = 'simple-table__product-title-link';
      titleLink.textContent = item.title;
      if (item.url) titleLink.href = item.url;

      title.appendChild(titleLink);
      card.appendChild(title);

      if (item.url && item.buttonText) {
        const button = document.createElement('a');
        button.className = 'btn btn--primary btn--small';
        button.href = item.url;

        const span = document.createElement('span');
        span.className = 'btn__text flex gap-1 items-center';
        span.textContent = item.buttonText;

        button.appendChild(span);
        card.appendChild(button);
      }

      cell.innerHTML = '';
      cell.appendChild(card);
    });

    // [カスタマイズ追記 2026-10-08] SP用の表カード（simple-table-mobile）は CSS で廃止済み（2026-07-02〜横スクロール表示に統一）で
    // 常に非表示だったため、JS での生成処理を削除
  }
};

  const initFaq = () => {
    const faqs = document.querySelectorAll('.article-faq details');

    faqs.forEach((faq) => {
      const updateState = () => {
        faq.classList.toggle('is-open', faq.open);
      };

      updateState();
      faq.addEventListener('toggle', updateState);
    });

    const faqItems = document.querySelectorAll('.article-faq details');

    faqItems.forEach((item) => {
      const summary = item.querySelector('summary');
      const content = item.querySelector('div');

      if (!summary || !content) return;
      if (item.dataset.faqInitialized === 'true') return;
      item.dataset.faqInitialized = 'true';

      if (item.hasAttribute('open')) {
        item.classList.add('is-open');
        content.style.height = 'auto';
        content.style.opacity = '1';
      } else {
        content.style.height = '0px';
        content.style.opacity = '0';
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = item.hasAttribute('open');

        if (isOpen) {
          const contentHeight = content.scrollHeight;
          content.style.height = contentHeight + 'px';

          requestAnimationFrame(() => {
            item.classList.remove('is-open');
            content.style.height = '0px';
            content.style.opacity = '0';
          });

          // [カスタマイズ追記 2026-10-09] opacity(0.25秒) の終了や中の要素のトランジションでも反応し、
          // height(0.35秒) のアニメーション途中で閉じていたため、本体の height の終了だけを待つ（開くときも同様）
          const handleClose = function (e) {
            if (e.target !== content || e.propertyName !== 'height') return;
            item.removeAttribute('open');
            content.removeEventListener('transitionend', handleClose);
          };

          content.addEventListener('transitionend', handleClose);
        } else {
          item.setAttribute('open', '');
          const contentHeight = content.scrollHeight;

          item.classList.add('is-open');
          content.style.height = '0px';
          content.style.opacity = '0';

          requestAnimationFrame(() => {
            content.style.height = contentHeight + 'px';
            content.style.opacity = '1';
          });

          const handleOpen = function (e) {
            if (e.target !== content || e.propertyName !== 'height') return;
            content.style.height = 'auto';
            content.removeEventListener('transitionend', handleOpen);
          };

          content.addEventListener('transitionend', handleOpen);
        }
      });
    });
  };

  // ========== [カスタマイズ追記] ==========
  // 記事本文内の商品埋め込みカード（<div class="card" data-url="...">）の
  // 「カートに追加」ボタンを、決済ページに直行する Cart Permalink 形式の
  // 「購入する」リンクに差し替える
  //
  // URL形式: /cart/{バリアントID}:1?channel=buy_button
  // バリアントIDは /products/{handle}.js から取得（在庫ありの先頭バリアント。在庫がなければ差し替えない）
  //
  // カード本体は別スクリプトが非同期でレンダリングするため、
  // MutationObserver で描画完了を監視して差し替える
  // 追記日: 2026-07-10
  // ======================================
  const initProductCardBuyLinks = () => {
    const CARD_SELECTOR = '.article__content .card[data-url], .rte .card[data-url]';
    const variantIdCache = new Map();

    const getVariantId = (handle) => {
      if (variantIdCache.has(handle)) return variantIdCache.get(handle);

      const promise = fetch(`/products/${handle}.js`)
        .then((res) => (res.ok ? res.json() : null))
        .then((product) => {
          if (!product || !product.variants || !product.variants.length) return null;
          // [カスタマイズ追記 2026-10-08] 以前は在庫がなくても先頭バリアントで「購入する」リンクを作っていた。
          // 在庫ありのバリアントがなければ null を返し、差し替えずに元のボタンのままにする
          const variant = product.variants.find((v) => v.available);
          return variant ? variant.id : null;
        })
        .catch((error) => {
          console.warn('Product card buy link: variant fetch failed:', handle, error);
          return null;
        });

      variantIdCache.set(handle, promise);
      return promise;
    };

    const findAddToCartEl = (card) => {
      const candidates = card.querySelectorAll('button, a');
      return (
        Array.from(candidates).find((el) => el.textContent.includes('カートに追加')) || null
      );
    };

    const processCard = async (card) => {
      if (card.dataset.buyLinkDone === 'true') return;

      const match = (card.dataset.url || '').match(/\/products\/([^/?#]+)/);
      if (!match) {
        card.dataset.buyLinkDone = 'true';
        return;
      }

      // カードのレンダリングがまだの場合は何もしない（Observerが再試行する）
      const addToCartEl = findAddToCartEl(card);
      if (!addToCartEl) return;

      card.dataset.buyLinkDone = 'true';

      const variantId = await getVariantId(match[1]);
      if (!variantId) return;

      const buyLink = document.createElement('a');
      buyLink.className = addToCartEl.className;
      buyLink.href = `/cart/${variantId}:1?channel=buy_button`;
      buyLink.innerHTML = addToCartEl.innerHTML.replace(/カートに追加/g, '購入する');

      addToCartEl.replaceWith(buyLink);
    };

    const processAllCards = () => {
      document.querySelectorAll(CARD_SELECTOR).forEach(processCard);
    };

    const observeTarget = document.querySelector('.article__content') || document.body;

    const observer = new MutationObserver(processAllCards);
    observer.observe(observeTarget, { childList: true, subtree: true });

    processAllCards();
  };

  const initArticlePage = async () => {
    moveArticleSections();
    // [カスタマイズ追記] 2026-07-10
    // 目次(INDEX)はデフォルトの記事テンプレートのみ生成する。
    // template.suffix は sections/main-article.liquid のインラインスクリプトが
    // window.__articleTplSuffix として出力（campaign等の代替テンプレでは値あり＝スキップ）。
    // 変数未定義（Liquid未反映）の場合は従来どおり生成にフォールバック。
    const isDefaultTemplate = !window.__articleTplSuffix;
    if (isDefaultTemplate) initArticleToc();
    initSupervisor();
    // [カスタマイズ追記 2026-10-08] 表の処理は商品情報の通信を待つため時間がかかる。
    // 待っている間 FAQ の開閉や購入ボタンが効かなかったので、FAQ・購入ボタンを先に実行し、表の処理を最後にする
    initFaq();
    initProductCardBuyLinks();
    await initSimpleTables();
    initTableScrollHints();
  };

  // [カスタマイズ追記 2026-10-09] 表が横にはみ出しているときだけ、表の上に「横にスクロールできます →」を出す
  // （表示はSPのみ。CSS の .article-table-scroll__hint で制御）
  const initTableScrollHints = () => {
    document.querySelectorAll('.article-table-scroll').forEach((wrap) => {
      if (wrap.previousElementSibling?.classList.contains('article-table-scroll__hint')) return;
      if (wrap.scrollWidth <= wrap.clientWidth + 1) return;

      const hint = document.createElement('p');
      hint.className = 'article-table-scroll__hint';
      hint.textContent = '横にスクロールできます →';
      wrap.insertAdjacentElement('beforebegin', hint);
    });
  };

  initArticlePage();




  const readMoreBlocks = document.querySelectorAll('[data-read-more]');

  readMoreBlocks.forEach((block) => {
    const content = block.querySelector('.article-sns-embed__caption-inner');
    const toggle = block.querySelector('[data-read-more-toggle]');

    if (!content || !toggle) return;

    // [カスタマイズ追記 2026-10-08]
    // --max-height は "12em" のため parseFloat では 12(px) となり、常にボタンが出ていた。
    // 折りたたみ状態（is-collapsed）で表示されているので、中身の高さ(scrollHeight)と
    // 見えている高さ(clientHeight)を比べ、はみ出していなければボタンを隠す。
    if (content.scrollHeight <= content.clientHeight + 4) {
      toggle.style.display = 'none';
      block.classList.remove('is-collapsed');
      return;
    }

    toggle.addEventListener('click', () => {
      const isCollapsed = block.classList.contains('is-collapsed');

      block.classList.toggle('is-collapsed', !isCollapsed);
      toggle.setAttribute('aria-expanded', String(isCollapsed));
      toggle.textContent = isCollapsed ? '閉じる' : '続きを読む';
    });
  });



  
  const sliders = document.querySelectorAll('[data-sns-slider]');

  sliders.forEach((slider) => {
    const track = slider.querySelector('[data-sns-slider-track]');
    const slides = Array.from(slider.querySelectorAll('[data-sns-slide]'));
    const prevBtn = slider.querySelector('[data-sns-slider-prev]');
    const nextBtn = slider.querySelector('[data-sns-slider-next]');
    const dots = Array.from(slider.querySelectorAll('[data-sns-slider-dot]'));

    if (!track || slides.length === 0) return;

    const getCurrentIndex = () => {
      const slideWidth = track.clientWidth;
      if (!slideWidth) return 0;
      return Math.round(track.scrollLeft / slideWidth);
    };

    const updateDots = () => {
      const currentIndex = getCurrentIndex();
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    };

    const scrollToIndex = (index) => {
      const clampedIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: track.clientWidth * clampedIndex,
        behavior: 'smooth',
      });
    };

    prevBtn?.addEventListener('click', () => {
      scrollToIndex(getCurrentIndex() - 1);
    });

    nextBtn?.addEventListener('click', () => {
      scrollToIndex(getCurrentIndex() + 1);
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        scrollToIndex(index);
      });
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateDots);
    });

    window.addEventListener('resize', updateDots);

    updateDots();
  });
});